import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    // 1. Selama proses pengecekan sesi, tampilkan pesan loading dan JANGAN lakukan apa-apa.
    if (loading) {
        return <div className="page-loading-text">Memverifikasi sesi...</div>;
    }

    // 2. Setelah pengecekan selesai (loading = false), baru putuskan.
    //    Jika tidak terautentikasi, baru arahkan ke login.
    if (!isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // 3. Jika terautentikasi, tampilkan halamannya.
    return children;
};

export default ProtectedRoute;